import {POST_INVOLVEMENT_PACKAGE} from '../actiontypes';
import {GroupTasksUrl} from '../apiUrls';

export const postInvolvementPackages = (engagementId, taskId, payload) => {
	const url = GroupTasksUrl(engagementId, taskId);
	return {
		type: POST_INVOLVEMENT_PACKAGE,
		meta: {
			api: {
				url,
				method: 'POST',
				data: payload
			}
		}
	};
};
